// extracted by mini-css-extract-plugin
export default {"payComponent":"paymentType_payComponent__tub9B","subscription":"paymentType_subscription__Vbsmt","subscription_item":"paymentType_subscription_item__8g7CB"};